import {
  Button,
  DefinitionListItem,
  DefinitionTerm,
  DefinitionValue,
} from '@apexinternal/ui-components'
import { Box, Stack, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { AccountNote } from '../../types/AccountNote'
import {
  formatISODateToLongDate,
  isFirstDateBeforeSecondDate,
} from '../../utils'

interface AccountNotesProps {
  accountNotes: AccountNote[]
}

const SHOW_MORE_NOTES_THRESHOLD = 2

const AccountNotes = ({ accountNotes }: AccountNotesProps) => {
  const [showMore, setShowMore] = useState(false)
  const accountNotesDescending = [...accountNotes]
    .sort((accountNoteA, accountNoteB) => {
      const accountNoteADate =
        accountNoteA.lastUpdated || accountNoteA.createDate
      const accountNoteBDate =
        accountNoteB.lastUpdated || accountNoteB.createDate
      if (isFirstDateBeforeSecondDate(accountNoteADate, accountNoteBDate)) {
        return -1
      } else if (
        isFirstDateBeforeSecondDate(accountNoteBDate, accountNoteADate)
      ) {
        return 1
      } else {
        return 0
      }
    })
    .reverse()

  return (
    <DefinitionListItem data-testid="account-notes">
      <DefinitionTerm>Account Notes</DefinitionTerm>
      <DefinitionValue>
        <Stack spacing="1rem" alignItems="start">
          {(showMore
            ? accountNotesDescending
            : accountNotesDescending.slice(0, SHOW_MORE_NOTES_THRESHOLD)
          ).map(({ line, createDate, lastUpdated }) => (
            <Box key={`${line}${createDate}${lastUpdated}`}>
              <Text fontWeight="semibold">
                {formatISODateToLongDate(lastUpdated || createDate)}
              </Text>
              <Text>{line}</Text>
            </Box>
          ))}
          {accountNotesDescending.length > SHOW_MORE_NOTES_THRESHOLD && (
            <Button
              variant="link"
              onClick={() => setShowMore(previousShowMore => !previousShowMore)}
            >{`Show ${showMore ? 'Less' : 'More'}`}</Button>
          )}
        </Stack>
      </DefinitionValue>
    </DefinitionListItem>
  )
}

export default AccountNotes
